import { useEffect } from "react";

import { useAdvertiserStore } from "@stores/advertiser";
import { advertiserRestService } from "../advertiser-rest.service";

/** Dispara o fetch dos dados do anunciante ao montar o componente. */
export function useAdvertiserInit(): void {
  useEffect(() => {
    const { loading, fetched, fetchLoading, fetchFulfilled, fetchRejected } =
      useAdvertiserStore.getState();

    if (loading || fetched) return;

    fetchLoading();

    advertiserRestService
      .fetchAdvertiser()
      .then((data) => {
        fetchFulfilled(data);
      })
      .catch((err: unknown) => {
        fetchRejected(err);
      });
  }, []);
}
